import type { Photo } from '../types'

/** Defaults for the "defect from photos" dialog: first photo with a floor / trade wins. */
export const defectPrefill = (photos: Photo[]): { floorId: string | null; trade: string | null; thumbs: string[] } => ({
  floorId: photos.find((p) => p.floor)?.floor?.id ?? null,
  trade: photos.find((p) => p.trade)?.trade ?? null,
  thumbs: photos.map((p) => p.thumbUrl).filter((u): u is string => !!u),
})
